<template>
  <div class="footer-div">
    <div class="footer-center">
      <div class="footer-center-logo-div">
          <img class="footer-logo" src="../../public/img/home-logo.png" alt="">
        <br>
        <!-- <span class="footer-center-text">儒风商才 义利合一</span> -->
      </div>
      <div style="display: flex;justify-content: space-around;">
        <div class="footer-bidder-help-div">
          <img class="loneline-position" src="../../public/img/loneline.png">
          <span class="footer-text-title cursor-pointer-text" @click="jumpHelp('拍卖规则')">保证金规则</span><br>
          <span class="footer-text-context cursor-pointer-text" @click="jumpHelp('保证金规则')">竞拍流程</span><br>
          <span class="footer-text-context cursor-pointer-text" @click="jumpHelp('拍卖规则')">出价规则</span><br>
          <span class="footer-text-context cursor-pointer-text" @click="jumpHelp('拍卖规则')">延时规则</span>
        </div>
        <div class="footer-bidder-help-div">
          <img class="loneline-position" src="../../public/img/loneline.png">
          <span class="footer-text-title cursor-pointer-text" @click="jumpHelp('竞拍流程')">竞拍流程</span><br>
          <span class="footer-text-context cursor-pointer-text" @click="jumpHelp('缴纳次数')">缴纳次数</span><br>
          <span class="footer-text-context cursor-pointer-text" @click="jumpHelp('缴纳金额')">缴纳金额</span><br>
          <span class="footer-text-context cursor-pointer-text" @click="jumpHelp('缴纳方式')">缴纳方式</span>
        </div>
        <div class="footer-bidder-help-div">
          <img class="loneline-position" src="../../public/img/loneline.png">
          <span class="footer-text-title cursor-pointer-text" @click="jumpHelp('常见问题')">常见问题</span><br>
          <span class="footer-text-context cursor-pointer-text" @click="jumpHelp('常见问题')">平台收费规则</span><br>
          <span class="footer-text-context cursor-pointer-text" @click="jumpHelp('常见问题')">名词解释</span><br>
          <span class="footer-text-context cursor-pointer-text" @click="jumpHelp('常见问题')">如何办理过户</span>
        </div>
        <div class="footer-bidder-help-div">
          <img class="loneline-position" src="../../public/img/loneline.png">
          <span class="footer-text-title cursor-pointer-text">关于我们</span><br>
          <span class="footer-text-context">电话：0755-28194513</span><br>
          <span class="footer-text-context">QQ：3900827640</span><br>
          <span class="footer-text-context">邮箱：3900827640@qq.com</span><br>
          <span class="footer-text-context">地址：深圳市龙华观光路乐创荟大厦</span>
        </div>
      </div>

      <div class="footer-qualification-div">
        <span class="footer-qualification-text cursor-pointer-text" @click="previewImage('/img/paimaizizhi.png')">拍卖资质</span>
        <span class="footer-qualification-divider">|</span>
        <span class="footer-qualification-text cursor-pointer-text" @click="previewImage('/img/营业执照副.jpg')">拍卖营业执照</span>
        <span class="footer-qualification-divider">|</span>
        <span class="footer-qualification-text cursor-pointer-text" @click="previewImage('/img/艺术品经营单位正.jpg')">艺术品经营单位</span>
        <!-- <span class="footer-qualification-divider">|</span> -->
        <!-- <span class="footer-qualification-text cursor-pointer-text" @click="previewImage('/img/艺术品经营单位副.jpg')">艺术品经营单位副</span>
        <span class="footer-qualification-divider">|</span> -->
        <!-- <span class="footer-qualification-text cursor-pointer-text" >Copyright @2026</span>
        <span class="footer-qualification-text cursor-pointer-text" @click="jumpOut('粤ICP备2024238082号')">备案号:粤ICP备2024238082号</span> -->
      </div>
      <!-- <div class="footer-bidder-help-div erweima-div">
        <img class="footer-erweima-img" src="../../public/img/qiyeerweima.jpg" alt="">
        <br>
        <span class="footer-erweima-text">大国数智（深圳）公众号</span>
      </div>
      <div class="footer-bidder-help-div erweima-div">
        <img class="footer-erweima-img" src="../../public/img/paimaierweima.png" alt="">
        <br>
        <span class="footer-erweima-text">拍卖公众号</span>
      </div> -->
    </div>
    <div class="footer-bottom">
      <div class="footer-bootom-text">
        <span>大国数智（深圳）科技有限公司版权所有</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <span >Copyright @2026</span>
          &nbsp;&nbsp;&nbsp;&nbsp;
        <span class="footer-beian">
          <span class="cursor-pointer-text" @click="jumpIcp">粤ICP备2024238082号</span>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <img class="footer-beian-icon" src="/img/guohui.png" alt="公安备案图标">
          <span class="cursor-pointer-text" @click="jumpPolice">粤公网安备44030002015676号</span>
        </span>
      </div>
    </div>

    <el-dialog title="资质预览" :visible.sync="dialogVisible" width="70%">
      <img :src="currentImage" style="width: 100%;" alt="">
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'FooterView',
  data() {
    return {
      dialogVisible: false,
      currentImage: ''
    }
  },
  methods: {
    previewImage(imagePath) {
      this.currentImage = imagePath;
      this.dialogVisible = true;
    },
    jumpHelp (type) {
      this.$router.push({ path: "/help", query: { type } })
    },
    // 跳转工信部ICP备案查询
    jumpIcp () {
      window.open('https://beian.miit.gov.cn/#/Integrated/recordQuery?keyword=')
    },
    // 跳转公安备案查询
    jumpPolice () {
      window.open('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030002015676')
    },
    jumpOut (beianNumber) {
      // 工信部ICP备案查询，支持通过URL参数自动查询
      window.open(`https://beian.miit.gov.cn/#/Integrated/recordQuery?keyword=${encodeURIComponent(beianNumber)}`)
    }
  }
}
</script>

<style>
.cursor-pointer-text:hover {
  cursor: pointer;
  text-decoration: underline;
}

.footer-bootom-text {
  padding: 10px 0;
  margin: auto;
  width: 1200px;
  height: 100%;
  opacity: 1;
  /** 文本1 */
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 30px;
  color: rgba(51, 51, 51, 1);
}

.footer-beian {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
}

.footer-beian-icon {
  width: 16px;
  height: 16px;
  margin-right: 4px;
  flex-shrink: 0;
}

.footer-beian-row {
  display: flex;
  align-items: center;
  justify-content: center;
}

.erweima-div {
  text-align: center;
}

.footer-erweima-text {
  display: inline-block;
  margin-top: 10px;
  width: 145px;
  height: 24px;
  opacity: 1;
  /** 文本1 */
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 23.74px;
  color: rgba(255, 255, 255, 1);
}

.footer-erweima-img {
  width: 80px;
  height: 80px;
}

.footer-text-context {
  display: inline-block;
  margin-top: 15px;
  margin-left: 15px;
  height: 22px;
  opacity: 1;
  /** 文本1 */
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 21.1px;
  color: rgba(255, 255, 255, 1);
}

.loneline-position {
  margin-top: -10px;
}

.footer-text-title {
  margin-left: 10px;
  width: 110px;
  height: 30px;
  opacity: 1;
  /** 文本1 */
  font-size: 22px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 29.02px;
  color: rgba(255, 255, 255, 1);
}

.footer-center-logo-div {
  float: left;
}

.footer-bidder-help-div {
  min-width: 150px;
  margin-top: 71px;
  float: left;
}

.footer-center-text {
  margin-left: 53px;
  margin-top: 8px;
  display: inline-block;
  width: 180px;
  height: 26px;
  opacity: 1;
  /** 文本1 */
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 25.6px;
  color: rgba(255, 255, 255, 1);
}

.footer-logo {
  margin-left: 77px;
  margin-top: 89px;
  width: 100px;
  height: 100px;
  opacity: 1;
}

.footer-center {
  margin: 0 auto;
  width: 1300px;
  height: 330px;
  opacity: 1;
  background: rgba(64, 64, 64, 1);
}

.footer-bottom {
  text-align: center;
  margin: 0 auto;
  width: 1300px;
  opacity: 1;
  background: rgba(204, 204, 204, 1);
}

.footer-div {
  z-index: 0;
  background: rgba(238, 242, 245, 1);
}


.footer-qualification-div {
  text-align: center;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid rgba(100, 100, 100, 0.3);
}

.footer-qualification-text {
  display: inline-block;
  margin: 0 30px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: rgba(180, 180, 180, 1);
}

.footer-qualification-text:hover {
  cursor: pointer;
  color: rgba(255, 255, 255, 1);
  text-decoration: underline;
}

.footer-qualification-divider {
  display: inline-block;
  margin: 0 10px;
  color: rgba(150, 150, 150, 1);
  font-size: 14px;
}

.erweima-div {
  text-align: center;
}
</style>